import { useMemo } from 'react';

const useCleanText = (dirtyText) => {
  const cleanText = useMemo(() => {
    // Remove HTML tags
    return dirtyText.replace(/<\/?[^>]+(>|$)/g, "");
  }, [dirtyText]);

  return cleanText;
};

export default useCleanText;